import React, { useEffect, useState } from "react";
import {
    ResponsiveContainer,
    BarChart,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    Bar,
} from "recharts";
import { useTranslation } from "react-i18next";

export default function ReactiveWeeklyActiveEnergyChart({ deviceId, API_BASE }) {
    const { t } = useTranslation();
    const [data, setData] = useState([]);

    useEffect(() => {
        async function load() {
            try {
                const res = await fetch(
                    `${API_BASE}/reactive/daily-active-energy-history?deviceId=${deviceId}`
                );
                const json = await res.json();
                let history = json.history || [];

                setData(
                    history.map((d) => ({
                        date: d.day.split("T")[0],
                        dailyImport: Math.trunc(Number(d.daily_import || 0) * 1000) / 1000,
                        dailyExport: Math.trunc(Number(d.daily_export || 0) * 1000) / 1000,

                    }))
                );
            } catch (err) {
                console.error("ReactiveWeeklyActiveEnergyChart error:", err);
            }
        }

        load();
    }, [deviceId, API_BASE]);

    return (
        <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">
                {t('dashboard.weeklyActiveTitleIE')}
            </h3>

            <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data}>
                        <XAxis dataKey="date" stroke="#6B7280" />
                        <YAxis stroke="#6B7280" />
                        <Tooltip />
                        <Legend />

                        <Bar dataKey="dailyImport" name={t('dashboard.legendImportkWh')} fill="#10B981" />
                        <Bar dataKey="dailyExport" name={t('dashboard.legendExportkWh')} fill="#F59E0B" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
